'use client'

import {configurationType, userType} from "@/lib/definitions/definitions";
import {logout} from "@/lib/auth";
import toast from "react-hot-toast";
import Bugsnag from "@bugsnag/js";

type fetchApiProps = {
    body?: any,
    type?: 'POST' | 'GET' | 'PUT' | 'DELETE'
    configuration: configurationType,
    route: string
    securityToken: string | null
    needToken?: boolean
}

export function fetchApi({configuration, body, type = 'POST', route, securityToken, needToken = true}: fetchApiProps) {

    // if (!configuration?.config?.apiHost) {
    //     throw new Error('No configuration found')
    // }

    if (!securityToken && needToken) {
        throw new Error('No security token found')
    }

    const envVars = configuration.envVars

    const liamtoOrigin = envVars?.origin ?? 'https://liamto.aality.ovh'
    const apiHost = envVars?.apiHost ?? 'https://aality.api.preprod.liamto.com'
    const apiKey = envVars?.key ?? 'aality'
    const apiSecret = envVars?.secret ?? 'liamto'

    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('LiamtoOrigin', liamtoOrigin);
    myHeaders.append('Authorization', 'Basic ' + btoa(apiKey + ':' + apiSecret));
    myHeaders.append('SecurityToken', securityToken ?? '');

    let raw:string|null = null

    if (body) {
        raw = JSON.stringify({
            ...body
        });
    }

    let obj: RequestInit = {
        method: type,
        headers: myHeaders,
        redirect: 'follow',
    }

    if (type === 'POST' || type === 'PUT') {
        obj.body = raw
    }

    return fetch(`${apiHost}/api/${route}`, obj).then(res => {

            if (res.status === 500) {

               res.json().then(json => {
                   if (json?.code === 401) {
                       logout('fr', configuration, securityToken ?? undefined)
                   }
                   Bugsnag.notify(new Error(json))
               })


            }

            return res.json()

        }

    ).catch(error => {
        // toast.error('An error as occured \n ', {
        //     id: 'errorOnFetch'
        // });

        Bugsnag.notify(new Error(error))
    })

}
